<template>
  <vx-card v-if="rule" no-shadow>
    <div class="vx-row mb-6 mt-2">
      <div class="vx-col sm:w-4/5 w-full">
        <h2 style="font-size: revert; font-weight: 500">Notification rule</h2>
        <small>Last edit: {{ rule.savedAction.timestamp | formatDate }} by
          {{ rule.savedAction.userDisplayName }}</small>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Rule name</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-input class="w-full" v-model="rule.name" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Rule country</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <code>
          {{ rule.country }}
        </code>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Enable notification rule</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-switch color="success" v-model="rule.enabled" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Rule triggers on</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-select label="List type" multiple v-model="rule.listTypes" class="w-full">
          <vs-select-item :key="idx" :value="listType.type" :text="listType.text"
            v-for="(listType, idx) in listTypes" />
        </vs-select>
      </div>
    </div>

    <div v-if="rule.type === 'onSubmitListNotificationRule'">
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Score interval</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-row>
            <vs-input-number label="From" v-model="rule.scoreLower" :min="0" :max="5" :step="0.05" />
            <vs-input-number label="To" v-model="rule.scoreUpper" :min="0" :max="5" :step="0.05" />
          </vs-row>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Only consider specific category score</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-select label="None means entire list" v-model="rule.listCategory" class="w-full">
            <vs-select-item :key="idx" :value="category" :text="category"
              v-for="(category, idx) in questionCategories" />
          </vs-select>
        </div>
      </div>
    </div>
    <div v-else class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Time since last submit</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-select label="Notification is sent when this is exceeded" v-model="rule.inactivityPeriod">
          <vs-select-item :key="idx" :value="interval.time" :text="interval.name"
            v-for="(interval, idx) in inactivityIntervals" />
        </vs-select>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Who should receive notification?</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-select multiple v-model="rule.recipientRoles" class="w-full">
          <vs-select-item :key="idx" :value="role.id" :text="role.title + ' (' + role.id + ')'"
            v-for="(role, idx) in roles" />
        </vs-select>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Notification channels</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-row><span>LIFE app</span><vs-switch class="ml-2" color="success" v-model="rule.sendInApp" /></vs-row>
        <vs-row class="mt-2"><span>LIFE Workspace</span><vs-switch class="ml-2" color="success"
            v-model="rule.sendInVp" /></vs-row>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Notification title</span>
      </div>

      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea placeholder="Text message" v-model="rule.title" />
        <div @click="addTitlePlaceholder(ph)" class="cursor-pointer" v-for="(ph, idx) in placeholders" :key="idx">
          <vs-chip>
            {{ ph }}
          </vs-chip>
        </div>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Notification message</span>
      </div>

      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea placeholder="Text message" v-model="rule.message" />
        <div @click="addMessagePlaceholder(ph)" class="cursor-pointer" v-for="(ph, idx) in placeholders" :key="idx">
          <vs-chip>
            {{ ph }}
          </vs-chip>
        </div>
      </div>
    </div>

    <div v-if="rule.type === 'onSubmitListNotificationRule'">
      <vs-divider />

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Email resume</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-row><span>Send email resume?</span><vs-switch class="ml-2" color="success"
              v-model="rule.sendEmailResume" /></vs-row>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="rule.sendEmailResume">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Delay before sending email <br /><small>At least 90 minutes recommended</small></span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-slider v-model="rule.emailRelativeTimeDelay" :max="1440" :step="15" text-fixed="Minutes" />
          <span class="flex gap-1 items-center font-bold" v-if="rule.emailRelativeTimeDelay > 0">
            <span> Wait </span>
            <vs-chip color="primary">{{ parsedRelativeTimeDelay }}</vs-chip>
            <span> before sending </span>
          </span>
          <vs-chip color="primary" v-else>Send instantly</vs-chip>
        </div>
      </div>


      <div class="vx-row mb-6" v-if="rule.sendEmailResume">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Who should receive email resume?</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-select multiple v-model="rule.emailResumeRecipientRoles" class="w-full">
            <vs-select-item :key="idx" :value="role.id" :text="role.title + ' (' + role.id + ')'"
              v-for="(role, idx) in roles" />
          </vs-select>
        </div>
      </div>
    </div>

    <!-- Save & Remove Button -->
    <vs-row vs-justify="space-between" class="flex flex-wrap items-center mt-6">
      <vs-button @click="update">Save changes</vs-button>
      <vs-button color="danger" @click="promptDelete">Delete rule</vs-button>
    </vs-row>
  </vx-card>
</template>

<script>
import { mapGetters } from "vuex";
import parseDelay from "parse-duration";
import humanizeDuration from "humanize-duration";

export default {
  components: {},

  data() {
    return {
      id: null,
      listTypes: [],
      rule: null,
    };
  },
  methods: {
    async update() {
      var relativeTimeHours = Math.floor(this.rule.emailRelativeTimeDelay / 60);
      var relativeTimeMinutes = this.rule.emailRelativeTimeDelay % 60;

      if (relativeTimeHours.toString().length == 1) relativeTimeHours = "0" + relativeTimeHours;
      if (relativeTimeMinutes.toString().length == 1) relativeTimeMinutes = "0" + relativeTimeMinutes;

      var modifiedRule = {
        ...this.rule,
        emailRelativeTimeDelay: `${relativeTimeHours}:${relativeTimeMinutes}:00`,
      };

      await this.$store.dispatch("listRules/updateRule", modifiedRule);
      this.$vs.notify({
        title: "Saved",
        text: "Successfully saved rule",
      });
    },
    async promptDelete() {
      this.$vs.dialog({
        color: "danger",
        title: `Are you sure?`,
        text: "Are you sure you want to delete this notification rule?",
        accept: this.remove,
      });
    },
    async remove() {
      const activeCountry = this.$store.getters["venues/activeCountry"];
      await this.$store.dispatch("listRules/deleteRule", {
        id: this.rule.id,
        country: activeCountry.id,
      });
      this.$router.go(-1);
    },
    addTitlePlaceholder(ph) {
      this.rule.title = `${this.rule.title}{{${ph}}}`;
    },
    addMessagePlaceholder(ph) {
      this.rule.message = `${this.rule.message}{{${ph}}}`;
    },
    addEmailResumePlaceholder(ph) {
      this.rule.emailResumeSubjectTemplate = `${this.rule.emailResumeSubjectTemplate}{{${ph}}}`;
    },
  },
  computed: {
    ...mapGetters({
      questionCategories: "lists/questionCategories",
      placeholders: "listRules/placeholders",
      inactivityIntervals: "listRules/inactivityIntervals",
      roles: "roles",
    }),
    parsedRelativeTimeDelay() {
      return humanizeDuration(parseDelay(`${this.rule.emailRelativeTimeDelay}m`));
    },
  },
  async created() {
    this.id = this.$route.params.id;

    // await all
    await Promise.all([
      this.$store.dispatch("getRoles"),
      this.$store.dispatch("lists/getAllCategories"),
    ]);

    const activeCountry = this.$store.getters["venues/activeCountry"];
    const lists = await this.$store.dispatch(
      "lists/getLatestLists",
      activeCountry.id
    );
    this.listTypes = lists
      .flatMap((l) => l.lists)
      .map((l) => ({ text: l.title, type: l.type }));
    console.log("List types", this.listTypes);


    var ruleRaw = await this.$store.dispatch("listRules/getRule", this.id);
    console.log("Rule raw", ruleRaw);

    if (ruleRaw.emailRelativeTimeDelay != null && ruleRaw.emailRelativeTimeDelay.includes(":")) {
      var relativeTimeDelay = ruleRaw.emailRelativeTimeDelay.split(":");
      var relativeTimeDelayMinutes = parseInt(relativeTimeDelay[0]) * 60 + parseInt(relativeTimeDelay[1]);
      this.rule = {
        ...ruleRaw,
        emailRelativeTimeDelay: relativeTimeDelayMinutes,
      };
    } else {
      // Default relative time delay
      this.rule = {
        ...ruleRaw,
        emailRelativeTimeDelay: 120,
      };
    }

    console.log("Rule is now", this.rule);
  },
};
</script>
